import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FiltersService } from '../../core/services/declarations/filters.service';
import { DEPARTMENTS_TYPES } from '../../core/constants/client.constants';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { DeclarationsService } from '../../core/services/declarations/declarations.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-multiple-executors-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: './multiple-executors-modal.component.html',
  styleUrl: './multiple-executors-modal.component.scss'
})
export class MultipleExecutorsModalComponent {

  @Input() phases: any[] = [];
  @Output() closeEvent = new EventEmitter<void>();
  @Output() saveEvent = new EventEmitter<any[]>();
  
  executors = [];
  taskExecutors: { [key: string]: any } = {};
  phaseGroups: any[] = [];

  constructor(
    private filtersService: FiltersService,
    private declarationService: DeclarationsService,
    private authService: AuthService,
  ) { }

  async ngOnInit() {
    const user = this.authService.getUser();
    this.executors = (await this.filtersService.getUsers()).filter(u => user?.user?.department !== 'GENERAL' ? u.department === user?.user?.department : u.department);

    
    // Group tasks by phases and filter only incomplete and visible tasks
    this.phaseGroups = this.phases
      .map((phase, index) => {
        const incompleteTasks = phase.tasks.filter(task => !task.isDisabled && !task.value);
        return {
          phaseName: phase.name,
          phaseId: phase.id,
          phaseNumber: index + 1,
          tasks: incompleteTasks
        };
      })
      .filter(group => group.tasks.length > 0); // Only include phases with incomplete tasks
    
    // Initialize executors for all tasks
    this.phaseGroups.forEach(group => {
      group.tasks.forEach(task => {
        if (task.executor) {
          const executor = typeof task.executor === 'string' 
            ? this.executors.find(e => e.name === task.executor)
            : task.executor;
          this.taskExecutors[task.id] = executor?.id;
        }
      });
    });
  }

  onCloseModal() {
    this.closeEvent.emit();
  }

  async onSave() {
    const updates = [];
    
    for (const taskId in this.taskExecutors) {
      const executorId = this.taskExecutors[taskId];
      
      if (executorId) {
        updates.push({
          taskId: parseInt(taskId),
          executorId: executorId
        });
      }
    }

    // Save all executor assignments
    for (const update of updates) {
      if (update.taskId && update.executorId) {
        await this.declarationService.taskExecutorUpdate(update.taskId, update.executorId);
      }
    }

    this.saveEvent.emit(updates);
    this.onCloseModal();
  }

}

